import { api } from '@/services/api';
import { useQuery } from '@tanstack/react-query';
import { FeatureFlagName } from '@/utils/featureFlags';

export const GET_FEATURE_FLAGS_QUERY_KEY = 'tenants.getFeatureFlags';

export const useGetFeatureFlags = (tenantId: string) => {
  const { data, isLoading, error } = useQuery({
    queryKey: [GET_FEATURE_FLAGS_QUERY_KEY, tenantId],
    queryFn: () => api.tenants.getFeatureFlags(tenantId),
    select: data => data.data,
    enabled: Boolean(tenantId),
  });

  const isFeatureEnabled = (featureFlagName: FeatureFlagName): boolean => {
    return data?.[featureFlagName] ?? false;
  };

  return {
    featureFlags: data,
    isLoading,
    error,
    isFeatureEnabled,
  };
};
